import React from 'react';
import { motion } from 'framer-motion';

const PageHeader = ({ title, subtitle }) => {
  return (
    <section className="relative bg-forest py-14 sm:py-20 md:py-24 lg:py-28 overflow-hidden">
      {/* Geometric dot pattern */}
      <div className="absolute inset-0 pattern-overlay"></div>
      
      {/* Decorative gradient blobs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-emerald/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-sage/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl"
        >
          {/* Gold accent line */}
          <div className="gold-divider mb-4 sm:mb-6 md:mb-8"></div>
          
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-white mb-4 sm:mb-6 tracking-tight leading-[1.15]">
            {title}
          </h1>
          
          {subtitle && (
            <p className="text-white/70 max-w-2xl text-xs sm:text-base md:text-lg leading-relaxed font-body">
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHeader;
